class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    const productGridContainerEl = document.getElementById('ProductGridContainer');
    const collectionEl = productGridContainerEl ? productGridContainerEl.querySelector('.collection') : null;
    if (collectionEl) collectionEl.classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    const currentContainer = document.getElementById('ProductGridContainer');
    const newContainer = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer');
    if (!currentContainer || !newContainer) return;

    currentContainer.innerHTML = newContainer.innerHTML;

    currentContainer.querySelectorAll('.scroll-trigger').forEach((element) => {
      element.classList.add('scroll-trigger--cancel');
    });
  }

static renderProductCount(html) {
  const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
  
  const newCount = parsedHTML.getElementById('ProductCountDesktop');
  const containerDesktop = document.getElementById('ProductCountDesktop');
  
  if (newCount && containerDesktop) {
    containerDesktop.innerHTML = newCount.innerHTML;
    containerDesktop.classList.remove('loading');
  }

  const loadingSpinners = document.querySelectorAll(
    '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
  );
  loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
}

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

facetsToRender.forEach((elementToRender, index) => {
  const currentElement = document.getElementById(elementToRender.id);
  if (currentElement) {
    currentElement.innerHTML = elementToRender.innerHTML;
  } else {
    if (index > 0) {
      const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
      if (elementToRender.className === previousElementClassName) {
        const previousElement = document.getElementById(previousElementId);
        if (previousElement) {
          previousElement.after(elementToRender);
        }
        return;
      }
    }

    if (elementToRender.parentElement) {
      const parentInDom = document.querySelector(`#${elementToRender.parentElement.id} .js-filter`);
      if (parentInDom) {
        parentInDom.before(elementToRender);
      }
    }
  }
});

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

static renderActiveFacets(html) {
  const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

  activeFacetElementSelectors.forEach((selector) => {
    const activeFacetsElement = html.querySelector(selector);
    const domElement = document.querySelector(selector);
    if (!domElement) return;

    if (!activeFacetsElement) {
      // Only clear the active filters row, not the whole container
      const activeFiltersRow = domElement.querySelector('.active-filters-row');
      if (activeFiltersRow) activeFiltersRow.innerHTML = '';
      return;
    }

    // Update just the active filters row if it exists
    const newActiveFiltersRow = activeFacetsElement.querySelector('.active-filters-row');
    const existingActiveFiltersRow = domElement.querySelector('.active-filters-row');

    if (newActiveFiltersRow && existingActiveFiltersRow) {
      existingActiveFiltersRow.innerHTML = newActiveFiltersRow.innerHTML;
    } else {
      domElement.innerHTML = activeFacetsElement.innerHTML;
    }
  });

  FacetFiltersForm.toggleActiveFacets(false);
}

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting','#MobileFacetsResultCount','.active--facets-in-drawer'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    // Category circles live outside the .js-filter elements this class
    // normally patches, so their active state needs its own sync step.
    const newCategoryCircles = html.querySelector('[data-category-circles]');
    const currentCategoryCircles = document.querySelector('[data-category-circles]');
    if (newCategoryCircles && currentCategoryCircles) {
      currentCategoryCircles.innerHTML = newCategoryCircles.innerHTML;
      delete currentCategoryCircles.dataset.sliderInit; // let the slider re-bind on fresh nodes
      if (typeof window.initCategorySlider === 'function') {
        window.initCategorySlider();
      }
    }

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetSummary = target.querySelector('.mobile-facets__summary--inline');
    const sourceSummary = source.querySelector('.mobile-facets__summary--inline');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    const productGridEl = document.getElementById('product-grid');
    if (!productGridEl) return [];
    return [
      {
        section: productGridEl.dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

onActiveFilterClick(event) {
  event.preventDefault();
  FacetFiltersForm.toggleActiveFacets();

  const href = event.currentTarget.href;

  // If this is a "Clear All" link (goes to base collection URL with no filter params),
  // do a hard redirect to guarantee full page re-render with all filters restored
  const isClearAll = event.currentTarget.classList.contains('active-facets__button--clear-all') 
    || event.currentTarget.closest('.clear-all-item') !== null;

  if (isClearAll) {
    window.location.href = href;
    return;
  }

  const url = href.indexOf('?') == -1
    ? ''
    : href.slice(href.indexOf('?') + 1);
  FacetFiltersForm.renderPage(url);
}
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();



class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);


// Facetslider custom suf

// Add this PriceRange class to your existing facets.js file
// Keep all your existing code and add this new class

class PriceRangeSlider extends HTMLElement {
  #abortController;
  
  connectedCallback() {
    this.#abortController = new AbortController();
    
    // Get slider elements
const rangeLowerBound = this.querySelector('.range--min');
const rangeHigherBound = this.querySelector('.range--max');
    
    // Get text input elements (these are the ones that submit to the form)
    const textInputLowerBound = this.querySelector('input[name*="filter.v.price.gte"], input[name*="min_value"]');
    const textInputHigherBound = this.querySelector('input[name*="filter.v.price.lte"], input[name*="max_value"]');
    
    if (!rangeLowerBound || !rangeHigherBound || !textInputLowerBound || !textInputHigherBound) {
      console.warn('PriceRange: Required elements not found');
      return;
    }

    // Focus handler - select all text when focused
    textInputLowerBound.addEventListener("focus", () => textInputLowerBound.select(), { 
      signal: this.#abortController.signal 
    });
    textInputHigherBound.addEventListener("focus", () => textInputHigherBound.select(), { 
      signal: this.#abortController.signal 
    });

    // Text input change handlers
    textInputLowerBound.addEventListener("change", (event) => {
      event.preventDefault();
      const maxVal = parseInt(textInputHigherBound.value || event.target.getAttribute('data-max')) - 1;
      const minVal = parseInt(event.target.getAttribute('data-min') || 0);
      
      event.target.value = Math.max(Math.min(parseInt(event.target.value) || 0, maxVal), minVal);
      rangeLowerBound.value = event.target.value;
      this.updateSliderProgress();
    }, { signal: this.#abortController.signal });

    textInputHigherBound.addEventListener("change", (event) => {
      event.preventDefault();
      const minVal = parseInt(textInputLowerBound.value || event.target.getAttribute('data-min')) + 1;
      const maxVal = parseInt(event.target.getAttribute('data-max'));
      
      event.target.value = Math.min(Math.max(parseInt(event.target.value) || maxVal, minVal), maxVal);
      rangeHigherBound.value = event.target.value;
      this.updateSliderProgress();
    }, { signal: this.#abortController.signal });

    // Range slider change handlers (triggers form submission)
    rangeLowerBound.addEventListener("change", (event) => {
      event.stopPropagation();
      textInputLowerBound.value = event.target.value;
      // Trigger change event to submit form through existing facet system
      textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
    }, { signal: this.#abortController.signal });

    rangeHigherBound.addEventListener("change", (event) => {
      event.stopPropagation();
      textInputHigherBound.value = event.target.value;
      // Trigger change event to submit form through existing facet system
      textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
    }, { signal: this.#abortController.signal });

    // Range slider input handlers (real-time updates without form submission)
    rangeLowerBound.addEventListener("input", (event) => {
      const maxVal = parseInt(textInputHigherBound.value || event.target.max) - 1;
      event.target.value = Math.min(parseInt(event.target.value), maxVal);
      textInputLowerBound.value = event.target.value;
      this.updateSliderProgress();
    }, { signal: this.#abortController.signal });

    rangeHigherBound.addEventListener("input", (event) => {
      const minVal = parseInt(textInputLowerBound.value || event.target.min) + 1;
      event.target.value = Math.max(parseInt(event.target.value), minVal);
      textInputHigherBound.value = event.target.value;
      this.updateSliderProgress();
    }, { signal: this.#abortController.signal });

    // Initialize slider progress
    this.updateSliderProgress();
  }

  updateSliderProgress() {
const rangeLowerBound = this.querySelector('.range--min');
const rangeHigherBound = this.querySelector('.range--max');
    const rangeGroup = this.querySelector('.range-group');
    
    if (rangeLowerBound && rangeHigherBound && rangeGroup) {
      const minPercent = (parseInt(rangeLowerBound.value) / parseInt(rangeLowerBound.max)) * 100;
      const maxPercent = (parseInt(rangeHigherBound.value) / parseInt(rangeHigherBound.max)) * 100;
      
      rangeGroup.style.setProperty("--range-min", `${minPercent}%`);
      rangeGroup.style.setProperty("--range-max", `${maxPercent}%`);
    }
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }
}

// Register the custom element only if it doesn't exist
if (!window.customElements.get("price-range")) {
  window.customElements.define("price-range", PriceRangeSlider);
}

// Update your existing PriceRange class to work with the new slider
// Replace your existing PriceRange class with this updated version:
class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input.field__input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input.field__input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput && maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput && minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput && minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput && maxInput.value === '') minInput.setAttribute('data-max', minInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

// Keep your existing customElements.define for price-range if it exists
// The PriceRangeSlider will handle the slider functionality